import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './element/index'
import './styles/index.scss'
import i18n from './i18n'
import CommonComponents from './components'

Vue.config.productionTip = false
Vue.use(CommonComponents)
Vue.use(i18n)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
